import React from "react";
import styled from "styled-components";

import LineSeedKrRg from "../../../../atoms/text/lineSeedKr/lineSeedKrRg";

const LSRgH2HeadLine = (props) => {
  return <LSRgH2HeadLineWrapper {...props} />;
};

export default LSRgH2HeadLine;

const LSRgH2HeadLineWrapper = styled(LineSeedKrRg)`
  font-size: 18px;
  font-weight: 400;
  line-height: 25.2px;
  letter-spacing: -0.6px;

  color: #222222;
`;
